import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(hubpage)/news/_modules/fixedCategory/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(hubpage)/news/_modules/fixedCategory/item.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/web/oneroof-rebuild/src/app/(layoutpage)/(hubpage)/news/_modules/fixedCategory/search.js");
